import React, { useEffect, useState } from "react";
import { FaHandshake, FaArrowRight } from "react-icons/fa";
import MyPage from "../components/MyPage";

function History() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // 1. JSON Data Fetch Karvo (Jo file public folder ma hoy to direct path lakho)
    fetch("./api/history.json") 
      .then((response) => response.json())
      .then((json) => setData(json))
      .catch((error) => console.error("Error fetching data:", error));

    // 2. Animation Logic
    const timer = setTimeout(() => {
      document.querySelector(".timeline")?.classList.add("animate");
      document.querySelector(".history-section")?.classList.add("animate");
      document.querySelector(".inner-banner")?.classList.add("animate");
    }, 500); // Thodu delay rakhiye jethi data load thai jay

    return () => clearTimeout(timer);
  }, []);

  // Jo data load na thayo hoy to loading screen dekhade
  if (!data) return <div style={{textAlign: 'center', padding: '50px'}}>Loading...</div>;

  return (
    <>
      <MyPage
        title="History | Thrissur Jilla Pravasi Kootayma"
        description={data.about.paragraphs[0]}
        keywords="Thrissur Pravasi, Community Engagement"
      />

      {/* ===== INNER BANNER ===== */}
      <section className="inner-banner">
        <div className="inner-overlay"></div>
        <div className="inner-content">
          <h1>{data.banner.title}</h1>
        </div>
        <div className="breadcrumb">
          {data.banner.breadcrumb}
        </div>
      </section>

      {/* ===== HISTORY SECTION ===== */}
      <section className="history-section">
        <div className="history-wrapper">
          <div className="history-images">
            <img src={data.about.images.main} alt="Main" className="history-img-main" />
            <img src={data.about.images.small} alt="Small" className="history-img-small" />
          </div>

          <div className="history-content">
            <h2 className="history-title">
              <FaHandshake /> {data.about.title} <span></span>
            </h2>
            {data.about.paragraphs.map((para, index) => (
              <p key={index}>{para}</p>
            ))}
            <a href="/contact" className="history-btn">
              Contact Us <FaArrowRight />
            </a>
          </div>
        </div>
      </section>

      {/* ===== OUR JOURNEY SECTION ===== */}
      <section className="journey-section">
        <div className="journey-header">
          <h2>
            <FaHandshake /> {data.journey.title} <span></span>
          </h2>
          <p>{data.journey.description}</p>
        </div>

        <div className="timeline">
          {data.journey.timeline.map((item, index) => (
            <div key={index} className={`timeline-item ${index % 2 !== 0 ? "reverse" : ""}`}>
              {/* Left Side */}
              <div className={index % 2 === 0 ? "timeline-left" : "timeline-left images"}>
                {index % 2 === 0 ? (
                  <div className="journey-card">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                ) : (
                  item.images.map((img, i) => <img key={i} src={img} alt="journey" />)
                )}
              </div>

              {/* Center Year */}
              <div className="timeline-center">
                <span className="year">{item.year}</span>
                <span className="dot"></span>
              </div>

              {/* Right Side */}
              <div className={index % 2 !== 0 ? "timeline-right" : "timeline-right images"}>
                {index % 2 !== 0 ? (
                  <div className="journey-card">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                ) : (
                  item.images.map((img, i) => <img key={i} src={img} alt="journey" />)
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* ===== CSS ===== */}
      <style>{`
        .inner-banner {
  position: relative;
  height: 420px;
  background: url("/assets/banner.jpg") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding-top: 120px;
}

.inner-overlay {

  inset: 0;
  background: rgba(0,0,0,0.65);
}

.inner-content {
  position: relative;
  z-index: 1;
}

.inner-content h1 {
  font-size: 48px;
  font-weight: 700;
  font-family: "Merriweather", serif;
}

.breadcrumb {
  position: absolute;
  bottom: -20px;
  left: 55px;
  border-radius: 4px;
  background: var(--primary-color);
  padding: 10px 25px;
  font-size: 20px;
  font-weight: 500;
  color: #000;
  z-index: 1;
}

        /* ===== HISTORY ===== */
        .history-section {
          padding: 90px 80px;
          background: #fff;
        }

        .history-wrapper {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
        }

        .history-images {
          position: relative;
          overflow: hidden;
        }

        .history-img-main {
          width: 100%;
          border-radius: 10px;
        }

        .history-img-small {
          position: absolute;
          bottom: -40px;
          right: 0;
          width: 65%;
          border-radius: 10px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
          background: #fff;
          transform: translateX(40px);
        }

        .history-title {
          font-size: 34px;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
          font-family: "Merriweather", serif;
        }

        .history-title span {
          height: 2px;
          width: 60px;
          background: #000;
          display: inline-block;
          margin-left: 10px;
        }

        .history-content p {
          font-size: 16px;
          line-height: 1.8;
          color: #333;
          margin-bottom: 18px;
        }

        .history-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #a8cf45;
          color: #000;
          padding: 14px 26px;
          border-radius: 6px;
          text-decoration: none;
          font-weight: 600;
        }

        /* ===== OUR JOURNEY ===== */
        .journey-section {
          padding: 100px 80px;
          background: #f7f9ee;
        }

        .journey-header {
          text-align: center;
          max-width: 800px;
          margin: 0 auto 80px;
        }

        .journey-header h2 {
          font-size: 36px;
          font-weight: 700;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          font-family: "Merriweather", serif;
        }

        .journey-header h2 span {
          width: 60px;
          height: 2px;
          background: #000;
          display: inline-block;
        }

        .timeline {
          position: relative;
        }

        .timeline::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: 50%;
          width: 2px;
          background: #a8cf45;
          transform: translateX(-50%);
        }

        .timeline-item {
          display: grid;
          grid-template-columns: 1fr 120px 1fr;
          gap: 40px;
          align-items: center;
          margin-bottom: 90px;
        }

        .timeline-center {
          text-align: center;
        }

        .year {
          background: #a8cf45;
          padding: 6px 16px;
          font-weight: 600;
          border-radius: 4px;
        }

/* ===== ANIMATED DOT (UNDER YEAR ONLY) ===== */
.dot {
  display: block;
  width: 14px;
  height: 14px;
  margin: 12px auto 0;   /* 🔥 year ni niche j */
  border-radius: 50%;
  background: #a8cf45;
  position: relative;
  animation: zoomPulse 1.6s ease-in-out infinite;
}

/* Outer rotating ring */
.dot::before {
  content: "";
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  border: 2px solid rgba(168, 207, 69, 0.6);
  animation: rotateRing 2.5s linear infinite;
}

/* ===== KEYFRAMES ===== */
@keyframes zoomPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.35);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes rotateRing {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


        .journey-card {
          background: #fff;
          padding: 30px;
          border-radius: 8px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
        }

        /* ===== IMAGES AS ROW (SIDE BY SIDE) ===== */
.images {
  display: flex;          /* row ma */
  flex-direction: row;    /* aju-baju */
  gap: 10px;              /* 🔥 10px gap */
  align-items: center;
}

.images img {

  width: 150px;
  height: 120px;
  object-fit: cover;
  border-radius: 6px;
  margin: 0;              /* old margin remove */
}
  /* ===== MOVE CARD & IMAGES TOWARDS CENTER ===== */

/* Default items (2014, 2018) */
.timeline-left {
  padding-right: 50px;   /* 60 → 30 (center તરફ) */
}

.timeline-right {
  padding-left: 50px;    /* 60 → 30 (center તરફ) */
}

/* Reverse item (2016) */
.timeline-item.reverse .timeline-left {
  padding-left: 30px;
}

.timeline-item.reverse .timeline-right {
  padding-right: 30px;
}

/* ===== TIMELINE ONLY – MOBILE FIX ===== */
/* ===================================
   TABLET & BELOW (≤ 992px)
=================================== */
@media (max-width: 992px) {

  /* History layout */
  .history-wrapper {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .history-img-small {
    position: relative;
    bottom: 0;
    right: 0;
    width: 100%;
    transform: none;
    margin-top: 20px;
  }

  /* Timeline */
  .timeline {
    padding-left: 50px;
  }

  .timeline::before {
    left: 25px;
    transform: none;
  }

  .timeline-item {
    display: block;
    position: relative;
    margin-bottom: 70px;
  }

  .timeline-center {
    position: absolute;
    left: -50px;
    top: 0;
    width: 50px;
    text-align: center;
  }

  .timeline-left,
  .timeline-right {
    padding: 0;
    margin-left: 20px;
  }

  .journey-card {
    padding: 22px;
    margin-bottom: 12px;
  }

  .images img {
    width: 90px;
    height: 70px;
  }
}

/* ===================================
   MOBILE (≤ 768px)
=================================== */
@media (max-width: 768px) {

  /* Banner */
  .inner-banner {
    height: 420px;
    padding-top: 90px;
  }

  .inner-content h1 {
    font-size: 36px;
    text-align: center;
  }

  .breadcrumb {
    left: 16px;
    bottom: -20px;
    padding: 8px 12px;
    font-size: 12px;
  }

  /* Section padding */
  .history-section,
  .journey-section {
    padding: 60px 20px;
  }

  /* Titles */
  .history-title,
  .journey-header h2 {
    font-size: 26px;
    flex-wrap: wrap;
  }

  .history-title span,
  .journey-header h2 span {
    display: none;
  }

  /* Timeline images */
  .images img {
    width: 80px;
    height: 65px;
  }
}

/* ===================================
   SMALL MOBILE (≤ 480px)
=================================== */
@media (max-width: 480px) {

  .inner-content h1 {
    font-size: 22px;
  }

  .journey-card h3 {
    font-size: 16px;
  }

  .journey-card p {
    font-size: 14px;
  }

  .images {
    gap: 6px;
  }

  .images img {
    width: 70px;
    height: 55px;
  }
}
/* ===== ANIMATION BASE ===== */
.journey-card,
.images {
  opacity: 0;
  transition: all 0.9s ease;
}

/* Left side items */
.timeline-left .journey-card,
.timeline-left.images {
  transform: translateX(-80px);
}

/* Right side items */
.timeline-right .journey-card,
.timeline-right.images {
  transform: translateX(80px);
}

/* ACTIVE STATE */
.timeline.animate .journey-card,
.timeline.animate .images {
  opacity: 1;
  transform: translateX(0);
}
/* ===== HISTORY SECTION ANIMATION ===== */
.history-images,
.history-content {
  opacity: 0;
  transition: all 1s ease;
}

/* Left image */
.history-images {
  transform: translateX(-80px);
}

/* Right content */
.history-content {
  transform: translateX(80px);
}

/* Active state */
.history-section.animate .history-images,
.history-section.animate .history-content {
  opacity: 1;
  transform: translateX(0);
}
/* ===== INNER BANNER ANIMATION ===== */

/* Initial state */

.inner-content {
  opacity: 0;
  transform: translateY(-40px);
  transition: all 1s ease;
}

.breadcrumb {
  opacity: 0;
  transform: translateY(40px);
  transition: all 1s ease;
}

/* Active state */
.inner-banner.animate {
  opacity: 1;
  transform: scale(1);
}

.inner-banner.animate .inner-content {
  opacity: 1;
  transform: translateY(0);
}

.inner-banner.animate .breadcrumb {
  opacity: 1;
  transform: translateY(0);
}
/* ===== FLOATING IMAGE ANIMATION ===== */
.images img {
  animation: floatImage 4s ease-in-out infinite;
}

/* Thodu natural feel mate different delay */
.images img:nth-child(1) {
  animation-delay: 0s;
}

.images img:nth-child(2) {
  animation-delay: 0.8s;
}

.images img:nth-child(3) {
  animation-delay: 1.6s;
}

/* ===== KEYFRAMES ===== */
@keyframes floatImage {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes floatImage {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(6px, -12px);
  }
  100% {
    transform: translate(0, 0);
  }
}

      `}</style>
    </>
  );
}

export default History;
